import { render, staticRenderFns } from "./CreateCommunicationFolioOpeningModal.vue?vue&type=template&id=481ae4ca&scoped=true"
import script from "./CreateCommunicationFolioOpeningModal.vue?vue&type=script&lang=js"
export * from "./CreateCommunicationFolioOpeningModal.vue?vue&type=script&lang=js"
import style0 from "./CreateCommunicationFolioOpeningModal.vue?vue&type=style&index=0&id=481ae4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ae4ca",
  null
  
)

export default component.exports